import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'auto' }); // use 'smooth' if you want
    }, 0);

    return () => clearTimeout(timeout);
  }, [location]);

  return null;
};

export default ScrollToTop;
